import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Modal } from 'react-bootstrap';
import CustomSpinner from './CustomSpinner';
import ReactWizard from 'react-bootstrap-wizard';

import '../App.scss';
import { useAuthContext } from '../context/authContext';
import AlertModalScore from './AlertModalScore';
import KnowledgeCheck from '../reducers/knowledgeCheck/model';
import {
  fetchKnowledgeCheck,
  submitKnowledgeCheck,
} from '../redux/actions/knowledgeCheckActions';
import { useDispatch, useSelector } from 'react-redux';
import { updateModuleSectionScore } from '../redux/actions/sectionActions';
import { BASE_API_URL, PRODUCT_NAME } from '../constants/constants';
import { requestPostApi } from '../services/api/api';

import { useTranslation } from 'react-i18next';

const capitalizeFirst = (str) => {
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};

const RadioList = ({
  text,
  options,
  index,
  answers = [],
  saveAnswers,
  setAnswers,
  knowledgeCheckID,
  question_type,
  question_id,
  optional,
}) => {
  // Sort the options by 'order' before rendering
  const sortedOptions = [...options].sort((a, b) => a.order - b.order);
  const [checkedItems, setCheckedItems] = useState([]);

  const onSave = (answers, item) => {
    if (!answers) {
      return;
    }

    const resUpdate = answers.find(
      (element) =>
        element.knowledge_check_question_id === item.knowledge_check_question_id
    );

    // Add index to item
    item = { ...item, index: index };

    if (resUpdate) {
      const updateAnswers = answers.map((ans) => {
        if (
          ans.knowledge_check_question_id === item.knowledge_check_question_id
        ) {
          ans = { ...item, ...{ kid: knowledgeCheckID } };
        }
        return ans;
      });
      setAnswers([...updateAnswers]);
      saveAnswers([...updateAnswers]);
    } else {
      setAnswers([...answers, { ...item, ...{ kid: knowledgeCheckID } }]);
      saveAnswers([...answers, { ...item, ...{ kid: knowledgeCheckID } }]);
    }
  };

  const isChecked = (item) => {
    let checked = answers.find((element) => element.id === item.id);
    return !!checked;
  };

  function parseTextWithMarkup(text) {
    // This regex looks for <b>, <i>, and <u> tags and captures the text between them
    const regex = /(<b>(.*?)<\/b>)|(<i>(.*?)<\/i>)|(<u>(.*?)<\/u>)|([^<]+)/g;
    const parts = text.match(regex);

    return parts.map((part, index) => {
      if (part.startsWith('<b>')) {
        return <strong key={index}>{part.slice(3, -4)}</strong>;
      }
      if (part.startsWith('<i>')) {
        return <em key={index}>{part.slice(3, -4)}</em>;
      }
      if (part.startsWith('<u>')) {
        return <u key={index}>{part.slice(3, -4)}</u>;
      }
      return part; // Plain text
    });
  }

  useEffect(() => {
    if (checkedItems == null || checkedItems.length == 0) {
      return;
    }
  }, [checkedItems]);

  useEffect(() => {
    if (question_type !== 1) {
      return;
    }
    if (checkedItems.length > 0) {
      // Collect scores from all items
      const scores = checkedItems.map((item) => item.score);

      const itemWithScores = {
        ...checkedItems[0],
        scores: scores,
      };

      setAnswers((answers) => {
        return onSave(answers, itemWithScores);
      });
    } else {
      const index = answers.findIndex(
        (element) => element.knowledge_check_question_id === question_id
      );

      // If the element is found, remove it
      if (index !== -1) {
        setAnswers([...answers.slice(0, index), ...answers.slice(index + 1)]);
      }
    }
  }, [checkedItems]);

  return (
    <Container>
      <Row>
        <Col
          sm
          className={
            'custom-label-question-screener text-color-gray font-poppins'
          }
        >
          {parseTextWithMarkup(text)}
          {optional === true ? (
            <span style={{ color: 'grey', fontSize: '0.8em' }}>
              {' '}
              (Optional)
            </span>
          ) : (
            <span style={{ color: 'red' }}> *</span>
          )}
        </Col>
      </Row>

      {question_type === null ||
      question_type === undefined ||
      question_type === 0 ? (
        <Row>
          {sortedOptions.map((item, idx) => (
            <Col
              className={
                typeof item.score !== 'undefined' ? 'screener-question' : ''
              }
              key={`${item.name.replace(/\s/g, '')}-${idx * 10}`}
            >
              <div className="custom-question-container">
                <div
                  className="radio"
                  onClick={() => {
                    setAnswers((answers) => {
                      return onSave(answers, item);
                    });
                  }}
                >
                  <label
                    style={{
                      height: '90px',
                    }}
                    id={`inline-check-${item.name.replace(/\s/g, '')}`}
                    className="custom-label-description text-color-gray font-poppins"
                  >
                    {item.name}
                  </label>
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'flex-end',
                    }}
                    className="custom-label-button-radio"
                  >
                    <input
                      name={`${item.knowledge_check_question_id}`}
                      type={'radio'}
                      value={
                        typeof item.score !== 'undefined'
                          ? item.score
                          : item.name.replace(/\s/g, '')
                      }
                      checked={isChecked(item)}
                      onChange={(item) => {
                        // console.log('Selected score:', item.score);
                      }}
                    />
                  </div>
                </div>
              </div>
            </Col>
          ))}
        </Row>
      ) : (
        ''
      )}

      {question_type === 1 ? (
        <Row>
          {sortedOptions.map((item, idx) => (
            <Col
              className={
                typeof item.score !== 'undefined' ? 'screener-question' : ''
              }
              key={`${item.name.replace(/\s/g, '')}-${idx * 10}`}
            >
              <div className="custom-question-container">
                <div className="radio">
                  <label
                    id={`inline-check-${item.name.replace(/\s/g, '')}`}
                    className="custom-label-description text-color-gray font-poppins"
                  >
                    {item.name}
                  </label>
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                    }}
                    className="custom-label-button-radio"
                  >
                    <input
                      id={`inline-check-${item.name.replace(/\s/g, '')}`}
                      name={`${item.knowledge_check_question_id}`}
                      type={'checkbox'}
                      value={
                        typeof item.score !== 'undefined'
                          ? item.score
                          : item.name.replace(/\s/g, '')
                      }
                      checked={
                        !!checkedItems.find(
                          (option) => option.id === item.id && option.checked
                        )
                      }
                      onChange={(event) => {
                        setCheckedItems((prev) => {
                          const foundIndex = prev.findIndex(
                            (option) => option.id === item.id
                          );

                          if (foundIndex !== -1) {
                            // If item exists, check if we should remove or update it
                            if (event.target.checked === false) {
                              // Remove the item if unchecked
                              return prev.filter(
                                (_, index) => index !== foundIndex
                              );
                            } else {
                              // Update the item's checked status
                              return prev.map((option, index) =>
                                index === foundIndex
                                  ? {
                                      ...option,
                                      checked: event.target.checked,
                                    }
                                  : option
                              );
                            }
                          } else {
                            // If item doesn't exist, add it with its checked status
                            return [
                              ...prev,
                              { ...item, checked: event.target.checked },
                            ];
                          }
                        });
                      }}
                    />
                  </div>
                </div>
              </div>
            </Col>
          ))}
        </Row>
      ) : (
        ''
      )}

      {question_type === 2 ? (
        <Row>
          <Col className={'screener-question'}>
            <div key={text}>
              <div className="custom-question-container">
                <div className="radio">
                  <label
                    id={`inline-check-${text.replace(/\s/g, '')}`}
                    className="custom-label-description text-color-gray font-poppins"
                  >
                    Please provide your response
                  </label>
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      height: '80px',
                    }}
                    className="custom-label-button-radio"
                  >
                    <textarea
                      id={`inline-check-${text.replace(/\s/g, '')}`}
                      name={`${text}`}
                      className="custom-label-description text-color-gray font-poppins"
                      style={{
                        width: '95%',
                        height: '60px',
                        boxSizing: 'border-box',
                        margin: '10px',
                        textAlign: 'left',
                        resize: 'none',
                      }}
                      onChange={(e) => {
                        if (e.target.value.trim().length > 0) {
                          const freeTextItem = {
                            knowledge_check_question_id: question_id,
                            name: 'FreeText',
                            score: e.target.value,
                          };

                          setAnswers((answers) => {
                            return onSave(answers, freeTextItem);
                          });
                        } else {
                          const index = answers.findIndex(
                            (element) =>
                              element.knowledge_check_question_id ===
                              question_id
                          );

                          // If the element is found, remove it
                          if (index !== -1) {
                            setAnswers([
                              ...answers.slice(0, index),
                              ...answers.slice(index + 1),
                            ]);
                          }
                        }
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      ) : (
        ''
      )}
    </Container>
  );
};

const Screener = ({ content, goBack, section, screener }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const {
    state: { user },
  } = useAuthContext();
  const [submittingKCID, setSubmittingKCID] = useState(0);
  const [answers, setAnswers] = useState([]);
  const [modal, setModal] = useState(false);
  const [completeKC, setCompleteKC] = useState(false);
  const [knowledgeChecks, setKnowledgeChecks] = useState([]);
  const [categoryResult, setCategoryResult] = useState(null);
  const [scores, setScores] = useState(null);
  const [categories, setCategories] = useState(null);
  const [categoryGroups, setCategoryGroups] = useState(null);

  const [knowledgeCheck, setKnowledgeCheck] = useState(null);
  const [currentGroupId, setCurrentGroupId] = useState(0);

  useEffect(() => {
    if (content) {
      setKnowledgeCheck(content[0]);
    }
  }, [content]);

  const onErrorClose = () => {
    setMessage('');
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  const { score, loading, fetchLoading, knowledgeCheckAnswers, screenerDone } =
    useSelector((state) => state.knowledgeCheck);

  const [message, setMessage] = useState('');
  const toggle = () => {
    setModal(!modal);
  };

  const submitScreenerResult = async (screenerResult) => {
    await requestPostApi(`${BASE_API_URL}/screener_results`, screenerResult);
  };

  useEffect(() => {
    if (
      (knowledgeCheckAnswers.length > 0 || screenerDone === true) &&
      completeKC
    ) {
      if (answers.length > 0 && screenerDone === true) {
        let finalScore = 0;
        let qaArr = new Map();
        let scoreCatArr = new Map();

        // Sort answers by index before processing
        const sortedAnswers = [...answers].sort((a, b) => {
          if (a.index === undefined) return 1;
          if (b.index === undefined) return -1;
          return a.index - b.index;
        });
        // Set answer scores
        for (let ans of sortedAnswers) {
          if (ans) {
            if ('scores' in ans) {
              // Multiple choice logic
              let totalScore = 0;
              for (let score of Object.values(ans.scores)) {
                totalScore += score;
              }
              finalScore += totalScore;
              qaArr.set(ans.index + 1, ans.scores);
            } else if ('name' in ans && ans.name === 'FreeText') {
              // Free text logic
              qaArr.set(ans.index + 1, ans.score);
            } else {
              // single answer
              finalScore += ans.score;
              qaArr.set(ans.index + 1, ans.score);
            }
          }
        }

        var literal_label = 'Literal Label';

        // If grouped set category scores
        if (knowledgeCheck.calculate_by_groups == true) {
          knowledgeCheck.scoreCategories.sort((a, b) => a.min - b.min);

          // Iterate categories
          for (let category of knowledgeCheck.scoreCategories) {
            var categorySum = 0;
            // Sum category group items
            category.group.forEach((item) => {
              if (Array.isArray(qaArr.get(item + 1))) {
                // item is an array sum all elements in array
                const scoresArray = qaArr.get(item + 1);
                categorySum += scoresArray.reduce(
                  (sum, current) => sum + current,
                  0
                );
              } else if (
                typeof qaArr.get(item + 1) === 'number' &&
                !isNaN(qaArr.get(item + 1))
              ) {
                // item is numeric, sum the value
                categorySum += qaArr.get(item + 1);
              } else {
                //  item is free text or null answer, don't sum
              }
            });
            scoreCatArr.set(category.min, categorySum);
          }

          setCategoryResult(null);
          setScores(scoreCatArr);
          setCategories(knowledgeCheck.scoreCategories);
          setCategoryGroups(knowledgeCheck.scoreCategoryGroups);

          literal_label = scoreLabelGrouped(scoreCatArr);
        } else {
          var matchedCategory;
          for (let category of knowledgeCheck.scoreCategories) {
            if (finalScore >= category.min && finalScore <= category.max) {
              matchedCategory = category;
            }
          }

          setCategoryResult(matchedCategory);
          literal_label = matchedCategory.literal_label;
        }

        let screener_result = {
          attempt_id: parseInt(new Date().getTime() / 1000),
          attempt_hash: user.email,
          attempt_date: new Date().toISOString(),
          client_id: user.schools[0].id,
          client_name: user.schools[0].name,
          screener_id: screener.id,
          screener_name: knowledgeCheck.name,
          score: finalScore,
          score_label: literal_label,
          qa_1: qaArr.get(1),
          qa_2: qaArr.get(2),
          qa_3: qaArr.get(3),
          qa_4: qaArr.get(4),
          qa_5: qaArr.get(5),
          qa_6: qaArr.get(6),
          qa_7: qaArr.get(7),
          qa_8: qaArr.get(8),
          qa_9: qaArr.get(9),
          qa_10: qaArr.get(10),
          qa_11: qaArr.get(11),
          qa_12: qaArr.get(12),
          qa_13: qaArr.get(13),
          qa_14: qaArr.get(14),
          qa_15: qaArr.get(15),
          qa_16: qaArr.get(16),
          qa_17: qaArr.get(17),
          qa_18: qaArr.get(18),
          qa_19: qaArr.get(19),
          qa_20: qaArr.get(20),
          qa_21: qaArr.get(21),
          qa_22: qaArr.get(22),
          qa_23: qaArr.get(23),
          qa_24: qaArr.get(24),
          qa_25: qaArr.get(25),
          qa_26: qaArr.get(26),
          qa_27: qaArr.get(27),
          qa_28: qaArr.get(28),
          qa_29: qaArr.get(29),
          qa_30: qaArr.get(30),
          qa_31: qaArr.get(31),
          qa_32: qaArr.get(32),
          qa_33: qaArr.get(33),
          qa_34: qaArr.get(34),
          qa_35: qaArr.get(35),
          qa_36: qaArr.get(36),
          qa_37: qaArr.get(37),
          qa_38: qaArr.get(38),
          qa_39: qaArr.get(39),
          qa_40: qaArr.get(40),
          score_cat1: scoreCatArr.get(1),
          score_cat2: scoreCatArr.get(2),
          score_cat3: scoreCatArr.get(3),
          score_cat4: scoreCatArr.get(4),
          score_cat5: scoreCatArr.get(5),
          score_cat6: scoreCatArr.get(6),
          score_cat7: scoreCatArr.get(7),
          score_cat8: scoreCatArr.get(8),
          score_cat9: scoreCatArr.get(9),
          score_cat10: scoreCatArr.get(10),
          score_cat11: scoreCatArr.get(11),
          score_cat12: scoreCatArr.get(12),
          score_cat13: scoreCatArr.get(13),
          score_cat14: scoreCatArr.get(14),
          score_cat15: scoreCatArr.get(15),
          event_type: screener.event_type,
        };
        // return;

        // Submit Screener Result
        submitScreenerResult({
          screener_result,
        });
      }

      toggle();
      setCompleteKC(false);

      if (section && screenerDone !== true) {
        dispatch(fetchKnowledgeCheck(section.id));
        dispatch(updateModuleSectionScore(score, section));
      }
    }

    // eslint-disable-next-line
  }, [knowledgeCheckAnswers, screenerDone, categoryResult]);

  const scoreLabelGrouped = (scoreCatArr) => {
    // Variable to hold the group with min=-1
    let noMatchedGroup = null;

    // Filter out groups with no matching categories and handle min=-1
    const validGroups = knowledgeCheck.scoreCategoryGroups
      .map((group) => {
        let groupWithCategories = {
          groupLabel: group.label,
          groupMin: group.min,
          groupCategories: [],
        };

        knowledgeCheck.scoreCategories.forEach((category) => {
          const categoryScore = scoreCatArr.get(category.min);
          if (
            categoryScore !== undefined &&
            categoryScore >= group.min &&
            categoryScore <= group.max
          ) {
            groupWithCategories.groupCategories.push(category);
          }
        });

        return groupWithCategories;
      })
      .filter((group) => {
        // If groupMin is -1, assign it to noMatchedGroup and exclude from validGroups
        if (group.groupMin === -1) {
          noMatchedGroup = group;
          return false; // Exclude from validGroups
        }
        return group.groupCategories.length > 0;
      })
      .sort((a, b) => a.groupMin - b.groupMin);

    const firstLiteralLabel =
      validGroups[0]?.groupCategories?.[0]?.literal_label || '';

    return firstLiteralLabel;
  };

  useEffect(() => {
    if (Array.isArray(content)) {
      const { _state, _globalAnswers } = getLocalAnswers(
        content.map((x) => new KnowledgeCheck(x))
      );
      setAnswers([..._globalAnswers]);
      setKnowledgeChecks([..._state]);
    } else {
      // console.error('Content is not an array:', content);
    }
  }, [content]);

  const onSubmitScreener = (knowledge_check) => {
    setMessage('');

    if (knowledge_check.answers && !knowledge_check.answers.length) {
      setMessage(t('please_complete'));
      return;
    }

    // Iterate knowledgeCheck questions and mark if answered
    knowledgeCheck.knowledge_check_questions_options_answers.forEach(
      (item, index) => {
        item.answered = false;
        knowledge_check.answers.forEach((answer, answerIndex) => {
          if (answer.knowledge_check_question_id === item.id) {
            item.answered = true;
          }
        });
      }
    );

    let allAnswered = true;

    // Iterate again and search for answered = false and optional = null or false
    knowledgeCheck.knowledge_check_questions_options_answers.forEach(
      (item, index) => {
        if (
          !item.answered &&
          (item.optional === null || item.optional === false)
        ) {
          allAnswered = false;
        }
      }
    );

    if (allAnswered === false) {
      setMessage('Please answer all the required questions.');
      return;
    }

    setCompleteKC(true);
    setSubmittingKCID(knowledge_check.id);

    dispatch(
      submitKnowledgeCheck(
        [],
        knowledge_check.knowledge_check_questions_options_answers,
        true
      )
    );
  };

  /**
   * @param knowledge_check_list
   * @param kc_id 'KC answers will be ignored for this id if it is present.
   * @returns {{_globalAnswers: *[], _state}}
   */

  const getLocalAnswers = (knowledge_check_list, kc_id = 0) => {
    let _globalAnswers = [];
    let _answers = [];

    const _state = knowledge_check_list.map((knowledge_check_answer) => {
      if (!kc_id || knowledge_check_answer.id !== kc_id) {
        knowledge_check_answer?.knowledge_check_questions_options_answers.forEach(
          (item) => {
            item.knowledge_check_options.forEach((option) => {
              // Check if the option is inside answers
              const answersList = item.knowledge_check_answers.filter(
                (answer) => {
                  return answer.knowledge_check_option_id === option.id;
                }
              );

              if (answersList.length) {
                _answers.push(option);
              }
            });
          }
        );
      }

      _globalAnswers = [..._globalAnswers, ..._answers];
      knowledge_check_answer.answers = [..._answers];
      _answers = []; // Clear the answers array for the next loop
      return knowledge_check_answer;
    });

    return { _state, _globalAnswers };
  };

  const saveAnswers = (_answers, id) => {
    if (_answers) {
      const filteredAnswers = _answers.filter((x) => x.kid === id);

      let temp = [...knowledgeChecks];

      temp.find((e) => e.id === id).answers = [...filteredAnswers];
      setKnowledgeChecks([...temp]);
    }
  };

  const transformKnowledgeCheckOptions = (kcOptions, questionIndex) => {
    return knowledgeCheck.knowledge_check_questions_options_answers[
      questionIndex
    ].knowledge_check_options.map((option) => {
      return {
        ...option,
      };
    });
  };

  if (fetchLoading) return <CustomSpinner />;

  if (!content || content.length === 0) return <div>No data</div>;

  return (
    <>
      {knowledgeChecks.map((knowledge_check_answer, key) => {
        return (
          <div key={key}>
            <Container fluid={true} className="knowledge-check-list-container">
              <Row className={`mt-3`}>
                <Col sm={8} lg={8} className={`d-flex align-items-center`}>
                  <h2 className="fw-300 font-poppins mb-1 font-25 text-color-primary">
                    {knowledge_check_answer?.name}
                  </h2>
                </Col>
              </Row>
              <Row>
                <Col>
                  <p className="mt-3 text-color-primary">
                    {content[0].instructions}
                  </p>
                </Col>
              </Row>
              {knowledgeChecks[0].knowledge_check_questions_options_answers
                .length == 40 ? (
                <ReactWizard
                  steps={[
                    {
                      stepName: 'First',
                      component: class FirstStep extends React.Component {
                        constructor(props) {
                          super(props);
                          this.state = {
                            firstStep: '1',
                          };
                        }
                        isValidated() {
                          setMessage('');
                          if (
                            (knowledge_check_answer.answers &&
                              !knowledge_check_answer.answers.length) ||
                            knowledge_check_answer.answers.length < 8
                          ) {
                            setMessage('Please answer all questions.');
                            return false;
                          }
                          window.scrollTo({
                            top: 0,
                            behavior: 'smooth',
                          });
                          return true;
                        }
                        render() {
                          return (
                            <div>
                              {knowledge_check_answer?.knowledge_check_questions_options_answers
                                .filter(
                                  (item, index) => index >= 0 && index < 8
                                )
                                .map((item, index) => (
                                  <Row
                                    id={`answers-cnt-${knowledge_check_answer.id}-${index}`}
                                    className={`mb-5 custom-question-answers answers-cnt-${knowledge_check_answer.id}`}
                                    key={`${item.name}-${
                                      item.knowledge_check_question_id +
                                      index * 5
                                    }`}
                                  >
                                    <Col lg={12}>
                                      <br />
                                      <RadioList
                                        question_type={item.question_type}
                                        question_id={item.id}
                                        optional={item.optional}
                                        text={item.name}
                                        options={transformKnowledgeCheckOptions(
                                          item.knowledge_check_options,
                                          index
                                        )}
                                        key={knowledge_check_answer.id}
                                        index={index}
                                        setAnswers={(answers) => {
                                          if (!answers) {
                                            return;
                                          }
                                          setAnswers(answers);
                                        }}
                                        knowledgeCheckID={
                                          knowledge_check_answer.id
                                        }
                                        saveAnswers={(_answers) => {
                                          if (!_answers) {
                                            return;
                                          }
                                          saveAnswers(
                                            _answers,
                                            knowledge_check_answer.id
                                          );
                                        }}
                                        answers={answers}
                                      />
                                    </Col>
                                  </Row>
                                ))}
                              <Row>
                                <Col className="wizard-footnote" lg={12}>
                                  <div className="al">Page 1 of 5</div>
                                </Col>
                              </Row>
                            </div>
                          );
                        }
                      },
                    },
                    {
                      stepName: 'Second',
                      component: class SecondStep extends React.Component {
                        constructor(props) {
                          super(props);
                          this.state = {
                            secondStep: '2',
                          };
                        }
                        isValidated() {
                          setMessage('');
                          if (
                            (knowledge_check_answer.answers &&
                              !knowledge_check_answer.answers.length) ||
                            knowledge_check_answer.answers.length < 16
                          ) {
                            setMessage('Please answer all questions.');
                            return false;
                          }
                          window.scrollTo({
                            top: 0,
                            behavior: 'smooth',
                          });
                          return true;
                        }
                        render() {
                          return (
                            <div>
                              {knowledge_check_answer?.knowledge_check_questions_options_answers
                                .filter(
                                  (item, index) => index >= 8 && index < 16
                                )
                                .map((item, index) => (
                                  <Row
                                    id={`answers-cnt-${
                                      knowledge_check_answer.id
                                    }-${index + 8}`}
                                    className={`mb-5 custom-question-answers answers-cnt-${knowledge_check_answer.id}`}
                                    key={`${item.name}-${
                                      item.knowledge_check_question_id +
                                      (index + 8) * 5
                                    }`}
                                  >
                                    <Col lg={12}>
                                      <br />
                                      <RadioList
                                        question_type={item.question_type}
                                        question_id={item.id}
                                        optional={item.optional}
                                        text={item.name}
                                        options={transformKnowledgeCheckOptions(
                                          item.knowledge_check_options,
                                          index + 8
                                        )}
                                        index={index + 8}
                                        setAnswers={setAnswers}
                                        knowledgeCheckID={
                                          knowledge_check_answer.id
                                        }
                                        saveAnswers={(_answers) => {
                                          saveAnswers(
                                            _answers,
                                            knowledge_check_answer.id
                                          );
                                        }}
                                        answers={answers}
                                      />
                                    </Col>
                                  </Row>
                                ))}
                              <Row>
                                <Col className="wizard-footnote" lg={12}>
                                  <div className="al">Page 2 of 5</div>
                                </Col>
                              </Row>
                            </div>
                          );
                        }
                      },
                    },
                    {
                      stepName: 'Third',
                      component: class ThirdStep extends React.Component {
                        constructor(props) {
                          super(props);
                          this.state = {
                            thirdStep: '3',
                          };
                        }
                        isValidated() {
                          setMessage('');
                          if (
                            (knowledge_check_answer.answers &&
                              !knowledge_check_answer.answers.length) ||
                            knowledge_check_answer.answers.length < 24
                          ) {
                            setMessage('Please answer all questions.');
                            return false;
                          }
                          window.scrollTo({
                            top: 0,
                            behavior: 'smooth',
                          });
                          return true;
                        }
                        render() {
                          return (
                            <div>
                              {knowledge_check_answer?.knowledge_check_questions_options_answers
                                .filter(
                                  (item, index) => index >= 16 && index < 24
                                )
                                .map((item, index) => (
                                  <Row
                                    id={`answers-cnt-${
                                      knowledge_check_answer.id
                                    }-${index + 16}`}
                                    className={`mb-5 custom-question-answers answers-cnt-${knowledge_check_answer.id}`}
                                    key={`${item.name}-${
                                      item.knowledge_check_question_id +
                                      (index + 16) * 5
                                    }`}
                                  >
                                    <Col lg={12}>
                                      <br />
                                      <RadioList
                                        question_type={item.question_type}
                                        question_id={item.id}
                                        optional={item.optional}
                                        text={item.name}
                                        options={transformKnowledgeCheckOptions(
                                          item.knowledge_check_options,
                                          index + 16
                                        )}
                                        index={index + 16}
                                        setAnswers={setAnswers}
                                        knowledgeCheckID={
                                          knowledge_check_answer.id
                                        }
                                        saveAnswers={(_answers) => {
                                          saveAnswers(
                                            _answers,
                                            knowledge_check_answer.id
                                          );
                                        }}
                                        answers={answers}
                                      />
                                    </Col>
                                  </Row>
                                ))}
                              <Row>
                                <Col className="wizard-footnote" lg={12}>
                                  <div className="al">Page 3 of 5</div>
                                </Col>
                              </Row>
                            </div>
                          );
                        }
                      },
                    },
                    {
                      stepName: 'Fourth',
                      component: class FourthStep extends React.Component {
                        constructor(props) {
                          super(props);
                          this.state = {
                            fourthStep: '4',
                          };
                        }
                        isValidated() {
                          setMessage('');
                          if (
                            (knowledge_check_answer.answers &&
                              !knowledge_check_answer.answers.length) ||
                            knowledge_check_answer.answers.length < 32
                          ) {
                            setMessage('Please answer all questions.');
                            return false;
                          }
                          window.scrollTo({
                            top: 0,
                            behavior: 'smooth',
                          });
                          return true;
                        }
                        render() {
                          return (
                            <div>
                              {knowledge_check_answer?.knowledge_check_questions_options_answers
                                .filter(
                                  (item, index) => index >= 24 && index < 32
                                )
                                .map((item, index) => (
                                  <Row
                                    id={`answers-cnt-${
                                      knowledge_check_answer.id
                                    }-${index + 24}`}
                                    className={`mb-5 custom-question-answers answers-cnt-${knowledge_check_answer.id}`}
                                    key={`${item.name}-${
                                      item.knowledge_check_question_id +
                                      (index + 24) * 5
                                    }`}
                                  >
                                    <Col lg={12}>
                                      <br />
                                      <RadioList
                                        question_type={item.question_type}
                                        question_id={item.id}
                                        optional={item.optional}
                                        text={item.name}
                                        options={transformKnowledgeCheckOptions(
                                          item.knowledge_check_options,
                                          index + 24
                                        )}
                                        index={index + 24}
                                        setAnswers={setAnswers}
                                        knowledgeCheckID={
                                          knowledge_check_answer.id
                                        }
                                        saveAnswers={(_answers) => {
                                          saveAnswers(
                                            _answers,
                                            knowledge_check_answer.id
                                          );
                                        }}
                                        answers={answers}
                                      />
                                    </Col>
                                  </Row>
                                ))}
                              <Row>
                                <Col className="wizard-footnote" lg={12}>
                                  <div className="al">Page 4 of 5</div>
                                </Col>
                              </Row>
                            </div>
                          );
                        }
                      },
                    },
                    {
                      stepName: 'Fifth',
                      component: class FifthStep extends React.Component {
                        constructor(props) {
                          super(props);
                          this.state = {
                            fifthStep: '5',
                          };
                        }

                        render() {
                          return (
                            <div>
                              {knowledge_check_answer?.knowledge_check_questions_options_answers
                                .filter(
                                  (item, index) => index >= 32 && index < 40
                                )
                                .map((item, index) => (
                                  <Row
                                    id={`answers-cnt-${
                                      knowledge_check_answer.id
                                    }-${index + 32}`}
                                    className={`mb-5 custom-question-answers answers-cnt-${knowledge_check_answer.id}`}
                                    key={`${item.name}-${
                                      item.knowledge_check_question_id +
                                      (index + 32) * 5
                                    }`}
                                  >
                                    <Col lg={12}>
                                      <br />
                                      <RadioList
                                        question_type={item.question_type}
                                        question_id={item.id}
                                        optional={item.optional}
                                        text={item.name}
                                        options={transformKnowledgeCheckOptions(
                                          item.knowledge_check_options,
                                          index + 32
                                        )}
                                        index={index + 32}
                                        setAnswers={setAnswers}
                                        knowledgeCheckID={
                                          knowledge_check_answer.id
                                        }
                                        saveAnswers={(_answers) => {
                                          saveAnswers(
                                            _answers,
                                            knowledge_check_answer.id
                                          );
                                        }}
                                        answers={answers}
                                      />
                                    </Col>
                                  </Row>
                                ))}
                              <Row>
                                <Col className="wizard-footnote" lg={12}>
                                  <div className="al">Page 5 of 5</div>
                                </Col>
                              </Row>
                            </div>
                          );
                        }
                      },
                    },
                  ]}
                  color="primary"
                  previousButtonClasses="custom-button-default font-poppins border-radius-12 font-18"
                  nextButtonClasses="custom-button-default font-poppins border-radius-12 font-18"
                  finishButtonClasses="custom-button-default font-poppins border-radius-12 font-18"
                  progressbar={false}
                  finishButtonClick={() =>
                    onSubmitScreener(knowledge_check_answer)
                  }
                  validate
                />
              ) : (
                // no pagination

                <div>
                  {knowledgeCheck?.knowledge_check_questions_options_answers.map(
                    (item, index) => (
                      <div key={`${item.title}-${item.id}`}>
                        {(index === 0 ||
                          item.knowledge_check_question_group_id !==
                            knowledgeCheck
                              ?.knowledge_check_questions_options_answers[
                              index - 1
                            ]?.knowledge_check_question_group_id) &&
                        item.knowledge_check_question_group_id > 0 ? (
                          <Row
                            id={`answers-cnt-${knowledgeCheck.id}-${index}`}
                            className={`mb-5 custom-question-answers answers-cnt-${knowledgeCheck.id}`}
                          >
                            <Col lg={12}>
                              <br />
                              {knowledgeCheck.questionGroups.find(
                                (group) =>
                                  group.id ===
                                  item.knowledge_check_question_group_id
                              )?.title ||
                                item.knowledge_check_question_group_id}
                              {/* {item.knowledge_check_question_group_title} */}
                            </Col>
                          </Row>
                        ) : (
                          ['']
                        )}
                        <Row
                          id={`answers-cnt-${knowledge_check_answer.id}-${index}`}
                          className={`mb-5 custom-question-answers answers-cnt-${knowledge_check_answer.id}`}
                          key={`${item.name}-${
                            item.knowledge_check_question_id +
                            index * 5 +
                            knowledge_check_answer
                              ?.knowledge_check_questions_options_answers.length
                          }`} // Adjust key to ensure uniqueness
                        >
                          <Col lg={12}>
                            <br />
                            <RadioList
                              question_type={item.question_type}
                              question_id={item.id}
                              optional={item.optional}
                              text={item.name}
                              options={transformKnowledgeCheckOptions(
                                item.knowledge_check_options,
                                index
                              )}
                              index={index}
                              setAnswers={setAnswers}
                              knowledgeCheckID={knowledge_check_answer.id}
                              saveAnswers={(_answers) =>
                                saveAnswers(_answers, knowledge_check_answer.id)
                              }
                              answers={answers}
                            />
                          </Col>
                        </Row>
                      </div>
                    )
                  )}
                </div>
              )}

              <br></br>

              <Modal show={message !== ''} fullscreen={'true'}>
                <Modal.Body>
                  <div>
                    <p className="text-danger text-center">{message}</p>
                    <button
                      onClick={onErrorClose}
                      className="custom-button-default w-100"
                    >
                      OK
                    </button>
                  </div>
                </Modal.Body>
              </Modal>

              <div className="custom-submit-container">
                {knowledgeChecks[0].knowledge_check_questions_options_answers
                  .length < 40 && (
                  <button
                    disabled={loading}
                    className={`custom-button-default font-poppins border-radius-12 font-18 d-flex justify-content-center`}
                    onClick={() => {
                      onSubmitScreener(knowledge_check_answer);
                    }}
                  >
                    {loading && submittingKCID === knowledge_check_answer.id ? (
                      <span className={`mr-2`}>
                        <CustomSpinner />
                      </span>
                    ) : (
                      ''
                    )}
                    <label className="custom-submit-button-text">
                      {loading && submittingKCID === knowledge_check_answer.id
                        ? t('submitting')
                        : t('submit')}
                    </label>
                  </button>
                )}
                <div className="flex-break"></div>

                {screener.mandatory == true ? (
                  <br />
                ) : (
                  <a href="#" className="gray-link" onClick={goBack}>
                    {screener.event_type == null || screener.event_type == 0
                      ? t('skip')
                      : t('dismiss_for_now')}
                  </a>
                )}

                <div className="flex-break"></div>

                <div className="max-width">
                  <span className="font-poppins font-13 text-color-gray mt-4">
                    {content[0].source}
                  </span>
                </div>

                <div className="flex-break"></div>

                <p className="font-poppins font-13 text-color-gray mt-4">
                  <i>{t('disclaimer')}</i>
                </p>
              </div>

              <Modal show={modal} fullscreen={'true'}>
                <Modal.Body>
                  <AlertModalScore
                    categoryResult={categoryResult}
                    scores={scores}
                    categories={categories}
                    categoryGroups={categoryGroups}
                    onClose={() => {
                      goBack();
                    }}
                  />
                </Modal.Body>
              </Modal>
            </Container>
          </div>
        );
      })}
    </>
  );
};

export default Screener;
